export default __webpack_public_path__ + "static/media/pruning.07b77661.jpg";